import { type FC } from 'react'

import clock from '@core/assets/v2/icons/time/regular/Icon-Clock-Regular.svg'
import clockCrossed from '@core/assets/v2/icons/time/regular/Icon-ClockCrossed-Regular.svg'
import clockItem from '@core/assets/v2/icons/time/regular/Icon-ClockItem-Regular.svg'
import clockPlus from '@core/assets/v2/icons/time/regular/Icon-ClockPlus-Regular.svg'
import clockPlusTop from '@core/assets/v2/icons/time/regular/Icon-ClockPlusTop-Regular.svg'
import history from '@core/assets/v2/icons/time/regular/Icon-History-Regular.svg'
import hourglass from '@core/assets/v2/icons/time/regular/Icon-Hourglass-Regular.svg'
import log from '@core/assets/v2/icons/time/regular/Icon-Log-Regular.svg'
import offTime from '@core/assets/v2/icons/time/regular/Icon-OffTime-Regular.svg'
import overtime from '@core/assets/v2/icons/time/regular/Icon-Overtime-Regular.svg'
import progres0 from '@core/assets/v2/icons/time/regular/Icon-Progres0-Regular.svg'
import progres25 from '@core/assets/v2/icons/time/regular/Icon-Progres25-Regular.svg'
import progres50 from '@core/assets/v2/icons/time/regular/Icon-Progres50-Regular.svg'
import progres75 from '@core/assets/v2/icons/time/regular/Icon-Progres75-Regular.svg'
import progres100 from '@core/assets/v2/icons/time/regular/Icon-Progres100-Regular.svg'
import reschedule from '@core/assets/v2/icons/time/regular/Icon-Reschedule-Regular.svg'
import shift from '@core/assets/v2/icons/time/regular/Icon-Shift-Regular.svg'
import shiftRequest from '@core/assets/v2/icons/time/regular/Icon-ShiftRequest-Regular.svg'
import shiftUser from '@core/assets/v2/icons/time/regular/Icon-ShiftUser-Regular.svg'
import stopwatch from '@core/assets/v2/icons/time/regular/Icon-Stopwatch-Regular.svg'
import timeMinus from '@core/assets/v2/icons/time/regular/Icon-TimeMinus-Regular.svg'
import timeRule from '@core/assets/v2/icons/time/regular/Icon-TimeRule-Regular.svg'
import timer from '@core/assets/v2/icons/time/regular/Icon-Timer-Regular.svg'
import clockSolid from '@core/assets/v2/icons/time/solid/Icon-Clock-Solid.svg'
import clockCrossedSolid from '@core/assets/v2/icons/time/solid/Icon-ClockCrossed-Solid.svg'
import clockPlusSolid from '@core/assets/v2/icons/time/solid/Icon-ClockPlus-Solid.svg'
import historySolid from '@core/assets/v2/icons/time/solid/Icon-History-Solid.svg'
import hourglassSolid from '@core/assets/v2/icons/time/solid/Icon-Hourglass-Solid.svg'
import logSolid from '@core/assets/v2/icons/time/solid/Icon-Log-Solid.svg'
import overtimeSolid from '@core/assets/v2/icons/time/solid/Icon-Overtime-Solid.svg'
import progres25Solid from '@core/assets/v2/icons/time/solid/Icon-Progres25-Solid.svg'
import progres50Solid from '@core/assets/v2/icons/time/solid/Icon-Progres50-Solid.svg'
import progres75Solid from '@core/assets/v2/icons/time/solid/Icon-Progres75-Solid.svg'
import progres100Solid from '@core/assets/v2/icons/time/solid/Icon-Progres100-Solid.svg'
import shiftSolid from '@core/assets/v2/icons/time/solid/Icon-Shift-Solid.svg'
import stopwatchSolid from '@core/assets/v2/icons/time/solid/Icon-Stopwatch-Solid.svg'
import timeRuleSolid from '@core/assets/v2/icons/time/solid/Icon-TimeRule-Solid.svg'

import { createIcon } from './createIcon'
import type { IconProps, TimeIconName } from './types'

export const IconClock = createIcon(clock, 'Clock')
export const IconClockCrossed = createIcon(clockCrossed, 'ClockCrossed')
export const IconClockItem = createIcon(clockItem, 'ClockItem')
export const IconClockPlus = createIcon(clockPlus, 'ClockPlus')
export const IconClockPlusTop = createIcon(clockPlusTop, 'ClockPlusTop')
export const IconHistory = createIcon(history, 'History')
export const IconHourglass = createIcon(hourglass, 'Hourglass')
export const IconLog = createIcon(log, 'Log')
export const IconOffTime = createIcon(offTime, 'OffTime')
export const IconOvertime = createIcon(overtime, 'Overtime')
export const IconProgres0 = createIcon(progres0, 'Progres0')
export const IconProgres25 = createIcon(progres25, 'Progres25')
export const IconProgres50 = createIcon(progres50, 'Progres50')
export const IconProgres75 = createIcon(progres75, 'Progres75')
export const IconProgres100 = createIcon(progres100, 'Progres100')
export const IconReschedule = createIcon(reschedule, 'Reschedule')
export const IconShift = createIcon(shift, 'Shift')
export const IconShiftRequest = createIcon(shiftRequest, 'ShiftRequest')
export const IconShiftUser = createIcon(shiftUser, 'ShiftUser')
export const IconStopwatch = createIcon(stopwatch, 'Stopwatch')
export const IconTimeMinus = createIcon(timeMinus, 'TimeMinus')
export const IconTimeRule = createIcon(timeRule, 'TimeRule')
export const IconTimer = createIcon(timer, 'Timer')
export const IconClockSolid = createIcon(clockSolid, 'ClockSolid')
export const IconClockCrossedSolid = createIcon(clockCrossedSolid, 'ClockCrossedSolid')
export const IconClockPlusSolid = createIcon(clockPlusSolid, 'ClockPlusSolid')
export const IconHistorySolid = createIcon(historySolid, 'HistorySolid')
export const IconHourglassSolid = createIcon(hourglassSolid, 'HourglassSolid')
export const IconLogSolid = createIcon(logSolid, 'LogSolid')
export const IconOvertimeSolid = createIcon(overtimeSolid, 'OvertimeSolid')
export const IconProgres25Solid = createIcon(progres25Solid, 'Progres25Solid')
export const IconProgres50Solid = createIcon(progres50Solid, 'Progres50Solid')
export const IconProgres75Solid = createIcon(progres75Solid, 'Progres75Solid')
export const IconProgres100Solid = createIcon(progres100Solid, 'Progres100Solid')
export const IconShiftSolid = createIcon(shiftSolid, 'ShiftSolid')
export const IconStopwatchSolid = createIcon(stopwatchSolid, 'StopwatchSolid')
export const IconTimeRuleSolid = createIcon(timeRuleSolid, 'TimeRuleSolid')

export const timeIcons: Record<TimeIconName, FC<IconProps>> = {
    Clock: IconClock,
    ClockCrossed: IconClockCrossed,
    ClockItem: IconClockItem,
    ClockPlus: IconClockPlus,
    ClockPlusTop: IconClockPlusTop,
    History: IconHistory,
    Hourglass: IconHourglass,
    Log: IconLog,
    OffTime: IconOffTime,
    Overtime: IconOvertime,
    Progres0: IconProgres0,
    Progres25: IconProgres25,
    Progres50: IconProgres50,
    Progres75: IconProgres75,
    Progres100: IconProgres100,
    Reschedule: IconReschedule,
    Shift: IconShift,
    ShiftRequest: IconShiftRequest,
    ShiftUser: IconShiftUser,
    Stopwatch: IconStopwatch,
    TimeMinus: IconTimeMinus,
    TimeRule: IconTimeRule,
    Timer: IconTimer,
    ClockSolid: IconClockSolid,
    ClockCrossedSolid: IconClockCrossedSolid,
    ClockPlusSolid: IconClockPlusSolid,
    HistorySolid: IconHistorySolid,
    HourglassSolid: IconHourglassSolid,
    LogSolid: IconLogSolid,
    OvertimeSolid: IconOvertimeSolid,
    Progres25Solid: IconProgres25Solid,
    Progres50Solid: IconProgres50Solid,
    Progres75Solid: IconProgres75Solid,
    Progres100Solid: IconProgres100Solid,
    ShiftSolid: IconShiftSolid,
    StopwatchSolid: IconStopwatchSolid,
    TimeRuleSolid: IconTimeRuleSolid,
}
